import { AutohomeEnvironment, WechatEnvironment, BrowserEnvironment, ICSAppEnvironment } from './environment/index';
import utils from '../utils/util';
let env = null;
export default {
  getEnv () {
    if (env) {
      return env;
    }
    if (utils.browser.isApp || utils.browser.isPriceApp) {
      env = new AutohomeEnvironment();
    } else if (utils.browser.isWechat) {
      env = new WechatEnvironment();
    } else if (window.ICSJavascriptBridge && typeof window.ICSJavascriptBridge.invoke === 'function') {
      env = new ICSAppEnvironment();
    } else {
      env = new BrowserEnvironment();
    }
    return env;
  }
};
